import {
  ActivityIndicator,
  StyleSheet,
  Text,
  TouchableOpacity,
  View
} from 'react-native'
import React, { useEffect } from 'react'
import { colorPalette, fontPalette, globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../../components/home/HomeDetailsHeader'
import Card from '../../../components/shared/card/Card'
import { useshiftstore } from '../../../stores/shift'
import { useLabourStore } from '../../../stores/labour'
import { useHomeStore } from '../../../stores/home'
import Toast from 'react-native-toast-message'
import { useTranslation } from 'react-i18next'

const Giveup = ({ navigation, route }) => {
  const { params } = route
  const {
    mostRecentUserOnBoardings: Id,
    refresh,
    time_In,
    time_Out,
    dayOfMonth,
    dayName,
    shiftiD
  } = params
  const [showHide, setShowHide] = React.useState(false)
  const [displaySubmit, setDisplaySubmit] = React.useState(true)
  const shiftStore = useshiftstore()
  const labourStore = useLabourStore()
  const homestore = useHomeStore()
  const { t } = useTranslation()

  const handlesubmit = async () => {
    const data: any = await shiftStore.updateGiveupShift(
      shiftiD,
      labourStore.labourData.entityId,
      labourStore.labourData.essUserKey,
      homestore.homeData.storeNumber
    )
    if (data?.responseStatus == 'true') {
      setDisplaySubmit(false)
      await Toast.show({
        type: 'success',
        position: 'bottom',
        text1: t(data?.responseMessage),
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60,
        onHide: () => {
          navigation.navigate('LabourSavourSchedule')
        }
      })
    } else {
      await Toast.show({
        type: 'error',
        position: 'bottom',
        text1: t(data?.responseMessage),
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60
      })
    }
  }

  return (
    <>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader />
        </View>

        <View style={[globalStyles.vCenterItems, { marginBottom: 10 }]}>
          <Text
            style={[
              globalStyles.text,
              globalStyles.fwBold,
              globalStyles.fs30,
              globalStyles.whiteTextColor,
              globalStyles.textCenter,
              { marginBottom: 5 }
            ]}
          >
            {t('Give Up Shift')}
          </Text>
          <TouchableOpacity
            style={[styles.custom]}
            onPress={() => navigation.navigate('LabourScreen')}
          >
            <Text style={{ fontSize: 20, color: 'white',fontFamily:fontPalette.primaryBold }}>
              {t('cancel')}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
      <View
        style={{
          marginTop: -44,
          padding: 16,
          flex: 1,
          justifyContent: 'space-between'
        }}
      >
        <Card>
          <View style={{ flexDirection: 'row' }}>
            <TouchableOpacity
              onPress={() => {
                setShowHide(!showHide)
              }}
            >
              <View
                style={{
                  justifyContent: 'center',
                  padding: 10,
                  backgroundColor: '#0B495C',
                  width: 70,
                  height: 70,
                  borderRadius: 5
                }}
              >
                <Text
                  style={{
                    fontSize: 25,
                    textAlign: 'center',
                    color: 'white',
                    fontFamily:fontPalette.primaryRegular
                  }}
                >
                  {dayOfMonth}
                </Text>
                <Text
                  style={{
                    fontSize: 16,
                    textAlign: 'center',
                    color: 'white',
                    fontFamily:fontPalette.primaryRegular
                  }}
                >
                  {dayName}
                </Text>
              </View>
            </TouchableOpacity>
            <View style={{ marginLeft: 10 }}>
              <Text
                style={{
                  fontWeight: 'bold',
                  marginBottom: 4,
                  fontFamily:fontPalette.primaryRegular
                }}
              >
                {time_In}-{time_Out}
              </Text>
            </View>
          </View>
          <View style={{ marginTop: 10 }}>
            <Text style={{ color: 'red',fontFamily:fontPalette.primaryRegular }}>
              {t('giveuptext')}
            </Text>
          </View>
        </Card>
        {shiftStore.loading ? (
          <ActivityIndicator />
        ) : (
          <>
            {displaySubmit && (
              <TouchableOpacity
                style={[styles.custom2, { backgroundColor: colorPalette.green }]}
                onPress={handlesubmit}
              >
                <View>
                  <Text
                    style={{ fontSize: 20,  color: 'white',fontFamily:fontPalette.primaryBold }}
                  >
                    {t('Submit Give Up Shift')}
                  </Text>
                </View>
              </TouchableOpacity>
            )}
          </>
        )}

      </View>
    </>
  )
}

export default Giveup

const styles = StyleSheet.create({
  custom: {
    justifyContent: 'center',
    flexDirection: 'row',
    paddingLeft: 16,
    paddingRight: 16,
    height: 40,
    width: '90%',
    alignItems: 'center',
    backgroundColor: colorPalette.skyBlue,
    color: 'black',
    borderWidth: 0,
    borderRadius: 11,
    marginTop: 5
  },
  custom2: {
    justifyContent: 'center',
    flexDirection: 'row',
    height: 40,
    width: '95%',
    paddingLeft: 16,
    paddingRight: 16,
    alignItems: 'center',
    alignSelf: 'center',
    borderWidth: 0,
    borderRadius: 10
  }
})
